import { jsx as _jsx } from "react/jsx-runtime";
import { LINK_FILTER } from '@as-react/common-types';
import { FilterSelectList } from './FilterSelectList';
export const FilterItemContentLinkFilter = ({ desktop, filter, onFilterItemChange, toggleFilterOptions, }) => (_jsx(FilterSelectList, { toggleFilterOptions: toggleFilterOptions, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: LINK_FILTER }));
